// extracted by mini-css-extract-plugin
export default {"button":"Messages_button__olzHx","label":"Messages_label__OpSTa"};